/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { ModelUtils } from '../util/ModelUtils';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { ExtensibleNode } from '../../core/models/ExtensibleNode';
import { Extension } from '../../core/models/Extension';
import { NodePath } from '../../core/models/NodePath';
import { MarshallCompat } from '../../compat/MarshallCompat';
import { Node } from '../../core/models/Node';

/**
 * A command used to delete all extensions from a node.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class DeleteAllExtensionsCommand extends AbstractCommand {
    public _parentPath : NodePath;

    public _oldExtensions : Array<any>;

    public constructor(parent? : any) {
        if(((parent != null && parent instanceof <any>ExtensibleNode) || parent === null)) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldExtensions===undefined) this._oldExtensions = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldExtensions===undefined) this._oldExtensions = null;
            (() => {
                this._parentPath = Library.createNodePath(parent);
            })();
        } else if(parent === undefined) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldExtensions===undefined) this._oldExtensions = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldExtensions===undefined) this._oldExtensions = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[DeleteAllExtensionsCommand] Executing.");
        this._oldExtensions = <any>([]);
        let parent : ExtensibleNode = <ExtensibleNode>this._parentPath.resolve(document);
        let extensions : Array<Extension> = parent.getExtensions();
        if(!this.isNullOrUndefined(extensions)) {
            extensions.forEach((extension) => {
                /* add */(this._oldExtensions.push(ModelUtils.marshalExtension(extension))>0);
            });
        }
        parent.clearExtensions();
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[DeleteAllExtensionsCommand] Reverting.");
        if(/* size */(<number>this._oldExtensions.length) === 0) {
            return;
        }
        let parent : ExtensibleNode = <ExtensibleNode>this._parentPath.resolve(document);
        this._oldExtensions.forEach(((parent) => {
            return (oldExtension) => {
                let extension : Extension = parent.createExtension();
                ModelUtils.unmarshalExtension(oldExtension, extension);
                parent.addExtension(extension.name, extension);
            }
        })(parent));
    }
}
DeleteAllExtensionsCommand["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteAllExtensionsCommand";
DeleteAllExtensionsCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




